module.exports = __webpack_public_path__ + "static/media/36.75643d08.jpg";